import React from 'react';
import PropTypes from 'prop-types';
import NewsSearchItem from "./NewsSearchItem";

export default class NewsSearchContent extends React.PureComponent {
    render() {
        return (
            <div
                className={`listing-items is-grid listing__items grid grid--12`}>
                    {this.props.items.map(item =>
                        <NewsSearchItem item={item} key={item.id}/>
                    )}
                </div>
        );
    }
}

NewsSearchContent.propTypes = {
    items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/news-search/js/NewsSearchContent.js